import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.anchoring],
    info: construction.info.anchoring,
    loaded: construction.parameters_loaded,
    selected: construction.selected.anchoring
  })
);
